module.exports = __webpack_public_path__ + "static/img/8.6119fed.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/1/sp/8.png
// module id = 5Am0
// module chunks = 0